module.exports = __webpack_public_path__ + "static/media/arrow-right-white.2823a84c.svg";